import React, {useContext, useEffect, useState, useRef} from 'react';
import brand from '../../../branding';
import _ from 'lodash'
// eslint-disable-next-line import/no-extraneous-dependencies

import GetAssetsListFunction from "../../../functions/GetAssetsListFunction";
import useDetailsResize from "../../../hooks/useDetailsResize";
import useSort from "../../../hooks/sortCard";
import filterHelper, { isGenericAsset } from '../../../hooks/useFilterHelper';

import PageHeader from '../../components/pageHeader';
import PageLayout from '../../components/pageLayout';
import AssetSearchTab from '../../components/assetsSearchTab';
import CardList from '../../components/Lists/cardList';
import AssetDetails from '../../components/assetDetail';
import useAssetSearch from '../../../hooks/useAssetSearch';
import Dropdown from "../../../components/dropdown";
import ApiStatus, {CALLING,EMPTY,POPULATED,TIMEOUT} from "../../../components/apiStatus";
import APIHelper from "../../../hooks/useAPIHelper";
import useInfiniteScroll from "../../../hooks/useInfiniteScroll";

import {
  PageHeaderText,
  PageCtn,
  SearchTabCtn,
  AssetsListCtn,
  AssetDetailsCtn,
  DropdownPosCtn,
  DropdownCtn,
  SearchBox
} from './index.style';
import AppStateContext from "../../context/appStateContext";
import AssetListContext from '../../context/assetListContext'
import JobListContext from "../../context/jobListContext";

const Assets: React.FC<any> = (...restProps): React.ReactElement => {

  const { selectedContract, token, selectedCustomerId, siteLogo, setAppPageDetails } = useContext(AppStateContext);
  const { clearSelectedReactiveJob } = useContext(JobListContext);
  const { openAssetDetails, assetList, updateAssetList, clearAssetList, filteredAssetList, updateOpenAssetDetails } = useContext(AssetListContext);

  const [ currentApiStatus, setCurrentApiStatus ] = useState(CALLING);

  const { handleSearch } = useAssetSearch(), { sortAsset } = useSort(), { filterDataByContract } = filterHelper(),getAsset = APIHelper();
  const { renderedData, handleBottom, updateRenderedData } = useInfiniteScroll(assetList, 'asset');
  let detailsHeight = useDetailsResize(document.getElementById('details'),window.innerHeight-245);

  useEffect(() => {
    let filter = `<Filters><CustomerCode><Like>${selectedCustomerId}</Like></CustomerCode></Filters>`;
    setAppPageDetails('assets');
    clearSelectedReactiveJob();
    clearAssetList();
    getAsset.run(GetAssetsListFunction,assetListCallback,[filter,token, selectedCustomerId]);
  },[]);

  useEffect(() => {
    updateOpenAssetDetails(true);
  }, [selectedContract]);

  useEffect(() => {
    updateRenderedData(filterDataByContract(filteredAssetList));
  },[filteredAssetList]);

  const assetListCallback = (data: [] | string) => {
    if(data == 'timeout') {
      setCurrentApiStatus(TIMEOUT);
      return;
    }

    if(data.length == 0) {
      setCurrentApiStatus(EMPTY);
      return;
    }

    if(!_.isArray(data)) data = [data];

    // PORTAL-127. Exclude Generic-named assets HERE, before useInfiniteScroll windows the list
    // into pages of 20 (src/hooks/useInfiniteScroll.tsx) - filtering only at render time inside
    // cardList/index.tsx left the fix technically correct but visually broken: whenever the
    // first 20-item page happened to be mostly/all Generic, that page rendered near-empty and
    // nothing else loaded until the user scrolled far enough to trigger the next page.
    const filteredData = filterDataByContract(data).filter((item) => !isGenericAsset(item));

    updateAssetList(filteredData);

    updateRenderedData(filterDataByContract(filteredData));

    setCurrentApiStatus(POPULATED);
  };

  return (
    <PageLayout handleBottom={handleBottom} list>
      <PageHeader backgroundImg={(brand.heroImages && brand.heroImages['assets']) || brand.heroImage || siteLogo.background_image[4]['image']['url']}>
        <PageHeaderText>Assets</PageHeaderText>
        <SearchBox type="text" placeholder="Search for an asset name, building.." onChange={handleSearch}/>
        <div />
      </PageHeader>
      <PageCtn>
        <SearchTabCtn>
          <AssetSearchTab/>
        </SearchTabCtn>
        <AssetsListCtn>
          <DropdownPosCtn>
            <DropdownCtn>
              <span>Sort by</span>
              <div>
                <Dropdown defaultVal={2} optionList="assetSort" onChange={(criteria) => sortAsset(criteria)} />
              </div>
            </DropdownCtn>
          </DropdownPosCtn>
          <ApiStatus status={currentApiStatus} type="ring">
            <CardList itemList={renderedData} page="assets" type="asset"/>
          </ApiStatus>
        </AssetsListCtn>
        {window.innerWidth> 1024 &&<AssetDetailsCtn active={openAssetDetails} id="details" height={detailsHeight}>
          <AssetDetails/>
        </AssetDetailsCtn>}
      </PageCtn>
    </PageLayout>
  );
};

export default Assets;
